var _path, _g, _line, _g2, _line2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 185,
    viewBox: "0 0 405 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V185H405V0H0ZM19.1399 184.232H36.7486V166.577H19.1399V184.232ZM19.1399 165.809H36.7486V148.154H19.1399V165.809ZM18.3743 184.232V166.577H0.765595V184.232H18.3743ZM0.765595 165.809H18.3743V148.154H0.765595V165.809ZM37.5142 184.232V166.577H55.1229V184.232H37.5142ZM55.8885 184.232H73.4972V166.577H55.8885V184.232ZM55.8885 165.809H73.4972V148.154H55.8885V165.809ZM37.5142 165.809H55.1229V148.154H37.5142V165.809ZM74.2628 184.232V166.577H91.8715V184.232H74.2628ZM92.637 184.232H110.246V166.577H92.637V184.232ZM92.637 165.809H110.246V148.154H92.637V165.809ZM74.2628 165.809H91.8715V148.154H74.2628V165.809ZM111.011 184.232V166.577H128.62V184.232H111.011ZM129.386 184.232H146.994V166.577H129.386V184.232ZM129.386 165.809H146.994V148.154H129.386V165.809ZM111.011 165.809H128.62V148.154H111.011V165.809ZM147.76 184.232V166.577H165.369V184.232H147.76ZM166.134 184.232H183.743V166.577H166.134V184.232ZM166.134 165.809H183.743V148.154H166.134V165.809ZM147.76 165.809H165.369V148.154H147.76V165.809ZM184.508 184.232V166.577H202.117V184.232H184.508ZM202.883 184.232H220.491V166.577H202.883V184.232ZM202.883 165.809H220.491V148.154H202.883V165.809ZM184.508 165.809H202.117V148.154H184.508V165.809ZM221.257 184.232V166.577H238.866V184.232H221.257ZM239.631 184.232H257.24V166.577H239.631V184.232ZM239.631 165.809H257.24V148.154H239.631V165.809ZM221.257 165.809H238.866V148.154H221.257V165.809ZM258.006 184.232V166.577H275.614V184.232H258.006ZM276.38 184.232H293.989V166.577H276.38V184.232ZM276.38 165.809H293.989V148.154H276.38V165.809ZM258.006 165.809H275.614V148.154H258.006V165.809ZM294.754 184.232V166.577H312.363V184.232H294.754ZM313.129 184.232H330.737V166.577H313.129V184.232ZM313.129 165.809H330.737V148.154H313.129V165.809ZM294.754 165.809H312.363V148.154H294.754V165.809ZM331.503 184.232V166.577H349.112V184.232H331.503ZM349.877 184.232H367.486V166.577H349.877V184.232ZM349.877 165.809H367.486V148.154H349.877V165.809ZM331.503 165.809H349.112V148.154H331.503V165.809ZM368.251 184.232V166.577H385.86V184.232H368.251ZM386.626 184.232H404.234V166.577H386.626V184.232ZM386.626 165.809H404.234V148.154H386.626V165.809ZM368.251 165.809H385.86V148.154H368.251V165.809ZM19.1399 147.386H36.7486V129.73H19.1399V147.386ZM0.765595 147.386H18.3743V129.73H0.765595V147.386ZM55.8885 147.386H73.4972V129.73H55.8885V147.386ZM37.5142 147.386H55.1229V129.73H37.5142V147.386ZM92.637 147.386H110.246V129.73H92.637V147.386ZM74.2628 147.386H91.8715V129.73H74.2628V147.386ZM129.386 147.386H146.994V129.73H129.386V147.386ZM111.011 147.386H128.62V129.73H111.011V147.386ZM166.134 147.386H183.743V129.73H166.134V147.386ZM147.76 147.386H165.369V129.73H147.76V147.386ZM202.883 147.386H220.491V129.73H202.883V147.386ZM184.508 147.386H202.117V129.73H184.508V147.386ZM239.631 147.386H257.24V129.73H239.631V147.386ZM221.257 147.386H238.866V129.73H221.257V147.386ZM276.38 147.386H293.989V129.73H276.38V147.386ZM258.006 147.386H275.614V129.73H258.006V147.386ZM313.129 147.386H330.737V129.73H313.129V147.386ZM294.754 147.386H312.363V129.73H294.754V147.386ZM349.877 147.386H367.486V129.73H349.877V147.386ZM331.503 147.386H349.112V129.73H331.503V147.386ZM386.626 147.386H404.234V129.73H386.626V147.386ZM368.251 147.386H385.86V129.73H368.251V147.386ZM19.1399 128.963H36.7486V111.307H19.1399V128.963ZM0.765595 128.963H18.3743V111.307H0.765595V128.963ZM55.8885 128.963H73.4972V111.307H55.8885V128.963ZM37.5142 128.963H55.1229V111.307H37.5142V128.963ZM92.637 128.963H110.246V111.307H92.637V128.963ZM74.2628 128.963H91.8715V111.307H74.2628V128.963ZM129.386 128.963H146.994V111.307H129.386V128.963ZM111.011 128.963H128.62V111.307H111.011V128.963ZM166.134 128.963H183.743V111.307H166.134V128.963ZM147.76 128.963H165.369V111.307H147.76V128.963ZM202.883 128.963H220.491V111.307H202.883V128.963ZM184.508 128.963H202.117V111.307H184.508V128.963ZM239.631 128.963H257.24V111.307H239.631V128.963ZM221.257 128.963H238.866V111.307H221.257V128.963ZM276.38 128.963H293.989V111.307H276.38V128.963ZM258.006 128.963H275.614V111.307H258.006V128.963ZM313.129 128.963H330.737V111.307H313.129V128.963ZM294.754 128.963H312.363V111.307H294.754V128.963ZM349.877 128.963H367.486V111.307H349.877V128.963ZM331.503 128.963H349.112V111.307H331.503V128.963ZM386.626 128.963H404.234V111.307H386.626V128.963ZM368.251 128.963H385.86V111.307H368.251V128.963ZM19.1399 110.539H36.7486V92.8838H19.1399V110.539ZM0.765595 110.539H18.3743V92.8838H0.765595V110.539ZM55.8885 110.539H73.4972V92.8838H55.8885V110.539ZM37.5142 110.539H55.1229V92.8838H37.5142V110.539ZM92.637 110.539H110.246V92.8838H92.637V110.539ZM74.2628 110.539H91.8715V92.8838H74.2628V110.539ZM129.386 110.539H146.994V92.8838H129.386V110.539ZM111.011 110.539H128.62V92.8838H111.011V110.539ZM166.134 110.539H183.743V92.8838H166.134V110.539ZM147.76 110.539H165.369V92.8838H147.76V110.539ZM202.883 110.539H220.491V92.8838H202.883V110.539ZM184.508 110.539H202.117V92.8838H184.508V110.539ZM239.631 110.539H257.24V92.8838H239.631V110.539ZM221.257 110.539H238.866V92.8838H221.257V110.539ZM276.38 110.539H293.989V92.8838H276.38V110.539ZM258.006 110.539H275.614V92.8838H258.006V110.539ZM313.129 110.539H330.737V92.8838H313.129V110.539ZM294.754 110.539H312.363V92.8838H294.754V110.539ZM349.877 110.539H367.486V92.8838H349.877V110.539ZM331.503 110.539H349.112V92.8838H331.503V110.539ZM386.626 110.539H404.234V92.8838H386.626V110.539ZM368.251 110.539H385.86V92.8838H368.251V110.539ZM19.1399 92.1162H36.7486V74.4606H19.1399V92.1162ZM0.765595 92.1162H18.3743V74.4606H0.765595V92.1162ZM55.8885 92.1162H73.4972V74.4606H55.8885V92.1162ZM37.5142 92.1162H55.1229V74.4606H37.5142V92.1162ZM92.637 92.1162H110.246V74.4606H92.637V92.1162ZM74.2628 92.1162H91.8715V74.4606H74.2628V92.1162ZM129.386 92.1162H146.994V74.4606H129.386V92.1162ZM111.011 92.1162H128.62V74.4606H111.011V92.1162ZM166.134 92.1162H183.743V74.4606H166.134V92.1162ZM147.76 92.1162H165.369V74.4606H147.76V92.1162ZM202.883 92.1162H220.491V74.4606H202.883V92.1162ZM184.508 92.1162H202.117V74.4606H184.508V92.1162ZM239.631 92.1162H257.24V74.4606H239.631V92.1162ZM221.257 92.1162H238.866V74.4606H221.257V92.1162ZM276.38 92.1162H293.989V74.4606H276.38V92.1162ZM258.006 92.1162H275.614V74.4606H258.006V92.1162ZM313.129 92.1162H330.737V74.4606H313.129V92.1162ZM294.754 92.1162H312.363V74.4606H294.754V92.1162ZM349.877 92.1162H367.486V74.4606H349.877V92.1162ZM331.503 92.1162H349.112V74.4606H331.503V92.1162ZM386.626 92.1162H404.234V74.4606H386.626V92.1162ZM368.251 92.1162H385.86V74.4606H368.251V92.1162ZM19.1399 73.6929H36.7486V56.0373H19.1399V73.6929ZM0.765595 73.6929H18.3743V56.0373H0.765595V73.6929ZM55.8885 73.6929H73.4972V56.0373H55.8885V73.6929ZM37.5142 73.6929H55.1229V56.0373H37.5142V73.6929ZM92.637 73.6929H110.246V56.0373H92.637V73.6929ZM74.2628 73.6929H91.8715V56.0373H74.2628V73.6929ZM129.386 73.6929H146.994V56.0373H129.386V73.6929ZM111.011 73.6929H128.62V56.0373H111.011V73.6929ZM166.134 73.6929H183.743V56.0373H166.134V73.6929ZM147.76 73.6929H165.369V56.0373H147.76V73.6929ZM202.883 73.6929H220.491V56.0373H202.883V73.6929ZM184.508 73.6929H202.117V56.0373H184.508V73.6929ZM239.631 73.6929H257.24V56.0373H239.631V73.6929ZM221.257 73.6929H238.866V56.0373H221.257V73.6929ZM276.38 73.6929H293.989V56.0373H276.38V73.6929ZM258.006 73.6929H275.614V56.0373H258.006V73.6929ZM313.129 73.6929H330.737V56.0373H313.129V73.6929ZM294.754 73.6929H312.363V56.0373H294.754V73.6929ZM349.877 73.6929H367.486V56.0373H349.877V73.6929ZM331.503 73.6929H349.112V56.0373H331.503V73.6929ZM386.626 73.6929H404.234V56.0373H386.626V73.6929ZM368.251 73.6929H385.86V56.0373H368.251V73.6929ZM19.1399 55.2697H36.7486V37.6141H19.1399V55.2697ZM0.765595 55.2697H18.3743V37.6141H0.765595V55.2697ZM55.8885 55.2697H73.4972V37.6141H55.8885V55.2697ZM37.5142 55.2697H55.1229V37.6141H37.5142V55.2697ZM92.637 55.2697H110.246V37.6141H92.637V55.2697ZM74.2628 55.2697H91.8715V37.6141H74.2628V55.2697ZM129.386 55.2697H146.994V37.6141H129.386V55.2697ZM111.011 55.2697H128.62V37.6141H111.011V55.2697ZM166.134 55.2697H183.743V37.6141H166.134V55.2697ZM147.76 55.2697H165.369V37.6141H147.76V55.2697ZM202.883 55.2697H220.491V37.6141H202.883V55.2697ZM184.508 55.2697H202.117V37.6141H184.508V55.2697ZM239.631 55.2697H257.24V37.6141H239.631V55.2697ZM221.257 55.2697H238.866V37.6141H221.257V55.2697ZM276.38 55.2697H293.989V37.6141H276.38V55.2697ZM258.006 55.2697H275.614V37.6141H258.006V55.2697ZM313.129 55.2697H330.737V37.6141H313.129V55.2697ZM294.754 55.2697H312.363V37.6141H294.754V55.2697ZM349.877 55.2697H367.486V37.6141H349.877V55.2697ZM331.503 55.2697H349.112V37.6141H331.503V55.2697ZM386.626 55.2697H404.234V37.6141H386.626V55.2697ZM368.251 55.2697H385.86V37.6141H368.251V55.2697ZM19.1399 36.8465H36.7486V19.1909H19.1399V36.8465ZM0.765595 36.8465H18.3743V19.1909H0.765595V36.8465ZM55.8885 36.8465H73.4972V19.1909H55.8885V36.8465ZM37.5142 36.8465H55.1229V19.1909H37.5142V36.8465ZM92.637 36.8465H110.246V19.1909H92.637V36.8465ZM74.2628 36.8465H91.8715V19.1909H74.2628V36.8465ZM129.386 36.8465H146.994V19.1909H129.386V36.8465ZM111.011 36.8465H128.62V19.1909H111.011V36.8465ZM166.134 36.8465H183.743V19.1909H166.134V36.8465ZM147.76 36.8465H165.369V19.1909H147.76V36.8465ZM202.883 36.8465H220.491V19.1909H202.883V36.8465ZM184.508 36.8465H202.117V19.1909H184.508V36.8465ZM239.631 36.8465H257.24V19.1909H239.631V36.8465ZM221.257 36.8465H238.866V19.1909H221.257V36.8465ZM276.38 36.8465H293.989V19.1909H276.38V36.8465ZM258.006 36.8465H275.614V19.1909H258.006V36.8465ZM313.129 36.8465H330.737V19.1909H313.129V36.8465ZM294.754 36.8465H312.363V19.1909H294.754V36.8465ZM349.877 36.8465H367.486V19.1909H349.877V36.8465ZM331.503 36.8465H349.112V19.1909H331.503V36.8465ZM386.626 36.8465H404.234V19.1909H386.626V36.8465ZM368.251 36.8465H385.86V19.1909H368.251V36.8465ZM19.1399 18.4232H36.7486V0.767635H19.1399V18.4232ZM0.765595 18.4232H18.3743V0.767635H0.765595V18.4232ZM55.8885 18.4232H73.4972V0.767635H55.8885V18.4232ZM37.5142 18.4232H55.1229V0.767635H37.5142V18.4232ZM92.637 18.4232H110.246V0.767635H92.637V18.4232ZM74.2628 18.4232H91.8715V0.767635H74.2628V18.4232ZM129.386 18.4232H146.994V0.767635H129.386V18.4232ZM111.011 18.4232H128.62V0.767635H111.011V18.4232ZM166.134 18.4232H183.743V0.767635H166.134V18.4232ZM147.76 18.4232H165.369V0.767635H147.76V18.4232ZM202.883 18.4232H220.491V0.767635H202.883V18.4232ZM184.508 18.4232H202.117V0.767635H184.508V18.4232ZM239.631 18.4232H257.24V0.767635H239.631V18.4232ZM221.257 18.4232H238.866V0.767635H221.257V18.4232ZM276.38 18.4232H293.989V0.767635H276.38V18.4232ZM258.006 18.4232H275.614V0.767635H258.006V18.4232ZM313.129 18.4232H330.737V0.767635H313.129V18.4232ZM294.754 18.4232H312.363V0.767635H294.754V18.4232ZM349.877 18.4232H367.486V0.767635H349.877V18.4232ZM331.503 18.4232H349.112V0.767635H331.503V18.4232ZM386.626 18.4232H404.234V0.767635H386.626V18.4232ZM368.251 18.4232H385.86V0.767635H368.251V18.4232Z",
    fill: "url(#paint0_radial_391_2343)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_391_2343)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.6152,
    y: 53.5,
    width: 78,
    height: 78,
    rx: 39,
    fill: "#3F3F59",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.6152,
    y: 55.5,
    width: 74,
    height: 74,
    rx: 37,
    stroke: "url(#paint1_linear_391_2343)",
    strokeWidth: 4,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_391_2343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.271 96.75C131.271 100.554 134.374 103.656 138.178 103.656H147.74V105.25C147.74 109.5 145.615 111.625 141.365 111.625H115.865C111.615 111.625 109.49 109.5 109.49 105.25V77.625C109.49 79.9625 111.403 81.875 113.74 81.875H141.365C145.615 81.875 147.74 84 147.74 88.25V89.8438H138.178C134.374 89.8438 131.271 92.9463 131.271 96.75ZM138.178 93.0312C136.138 93.0312 134.459 94.71 134.459 96.75C134.459 98.79 136.138 100.469 138.178 100.469H147.74V93.0312H138.178ZM139.283 98.875C138.114 98.875 137.137 97.9188 137.137 96.75C137.137 95.5812 138.093 94.625 139.262 94.625H139.283C140.452 94.625 141.408 95.5812 141.408 96.75C141.408 97.9188 140.452 98.875 139.283 98.875ZM134.99 73.375H115.334C113.868 73.375 112.678 74.565 112.678 76.0312C112.678 77.4975 113.868 78.6875 115.334 78.6875H141.301C140.983 75.1388 138.879 73.375 134.99 73.375Z",
    fill: "white"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 167.615,
    y1: 91.5,
    x2: 185.615,
    y2: 91.5,
    stroke: "#3F75FF",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_391_2343)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.615,
    y: 75.6154,
    width: 33.7692,
    height: 33.7692,
    rx: 16.8846,
    fill: "url(#paint2_linear_391_2343)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.615,
    y: 74.6154,
    width: 35.7692,
    height: 35.7692,
    rx: 17.8846,
    stroke: "#1D1D27",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.602 94.8338C207.368 94.8338 207.135 94.7449 206.956 94.5671C206.597 94.2105 206.595 93.6293 206.952 93.2709L208.756 91.4578C209.453 90.7684 209.834 89.8453 209.834 88.8553C209.834 87.8653 209.452 86.9386 208.758 86.2447C207.322 84.8073 204.983 84.8092 203.545 86.2447L201.743 88.056C201.386 88.4144 200.807 88.4172 200.447 88.0597C200.087 87.7031 200.085 87.1219 200.443 86.7635L202.247 84.9503C204.4 82.7971 207.903 82.7971 210.054 84.9485C211.095 85.988 211.667 87.3758 211.667 88.8553C211.667 90.3394 211.094 91.7245 210.051 92.7567L208.252 94.5652C208.073 94.744 207.838 94.8338 207.602 94.8338ZM202.752 100.053L204.566 98.2493C204.925 97.8918 204.927 97.3116 204.57 96.9532C204.212 96.5948 203.633 96.592 203.274 96.9495L201.459 98.7553C200.02 100.193 197.683 100.191 196.246 98.7553C194.809 97.318 194.809 94.9805 196.244 93.545L198.058 91.741C198.417 91.3835 198.419 90.8033 198.061 90.4448C197.704 90.0864 197.125 90.0837 196.765 90.4412L194.95 92.247C192.798 94.3984 192.798 97.8992 194.95 100.052C196.027 101.128 197.441 101.665 198.854 101.665C200.266 101.666 201.679 101.129 202.752 100.053ZM200.399 95.8981L205.923 90.3752C206.281 90.0168 206.281 89.4365 205.923 89.079C205.564 88.7215 204.985 88.7215 204.627 89.079L199.103 94.6019C198.744 94.9603 198.744 95.5406 199.103 95.8981C199.281 96.0768 199.516 96.1667 199.751 96.1667C199.985 96.1667 200.22 96.0768 200.399 95.8981Z",
    fill: "white"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 219.385,
    y1: 91.5,
    x2: 237.385,
    y2: 91.5,
    stroke: "#3F75FF",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_391_2343)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.385,
    y: 53.5,
    width: 78,
    height: 78,
    rx: 39,
    fill: "#3F3F59",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.385,
    y: 55.5,
    width: 74,
    height: 74,
    rx: 37,
    stroke: "url(#paint3_linear_391_2343)",
    strokeWidth: 4,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_391_2343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.885 73.375H267.885C263.635 73.375 261.51 75.5 261.51 79.75V105.25C261.51 109.5 263.635 111.625 267.885 111.625H284.885C289.135 111.625 291.26 109.5 291.26 105.25V79.75C291.26 75.5 289.135 73.375 284.885 73.375ZM276.385 107.375C275.212 107.375 274.26 106.423 274.26 105.25C274.26 104.077 275.212 103.125 276.385 103.125C277.558 103.125 278.51 104.077 278.51 105.25C278.51 106.423 277.558 107.375 276.385 107.375ZM279.572 81.3438H273.197C272.318 81.3438 271.604 80.6297 271.604 79.75C271.604 78.8703 272.318 78.1562 273.197 78.1562H279.572C280.452 78.1562 281.166 78.8703 281.166 79.75C281.166 80.6297 280.452 81.3438 279.572 81.3438Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_391_2343",
    x: 67.6152,
    y: 31.5,
    width: 122,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_2343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_2343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_391_2343",
    x: 81.1152,
    y: 45,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_2343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_2343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_391_2343",
    x: 161.615,
    y: 51.6154,
    width: 81.7695,
    height: 81.7692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_2343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_2343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_391_2343",
    x: 215.385,
    y: 31.5,
    width: 122,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_2343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_2343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_391_2343",
    x: 228.885,
    y: 45,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_391_2343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_391_2343",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_391_2343",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.5 92.5) rotate(90) scale(75.612 146.034)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_391_2343",
    x1: 128.615,
    y1: 53.5,
    x2: 128.615,
    y2: 131.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3970FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_391_2343",
    x1: 202.5,
    y1: 75.6154,
    x2: 202.5,
    y2: 109.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3970FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_391_2343",
    x1: 276.385,
    y1: 53.5,
    x2: 276.385,
    y2: 131.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3970FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletLink);
export default __webpack_public_path__ + "static/media/wallet-link.84ac52bc7eb9825e0e109367d9b9ffce.svg";
export { ForwardRef as ReactComponent };